import axios from 'axios';
import {useCookies} from "vue3-cookies";
import moment from 'moment';

const {cookies} = useCookies();
const svodApi = axios.create({
    baseURL: 'https://svod.polyanaski.ru/api/market',
    headers: {
        'mrktsid': cookies.get('server_sid') || "",
        // 'd_tk': cookies.get('testMode') ? (crypto ? crypto.randomUUID() : '') : null,
        'd_tk': cookies.get('testMode') ? 'c63d5e3f-f3db-4aac-be71-20af9e72fc4c' : null,
    }
});

svodApi.defaults.headers.post['Content-Type'] = 'application/json';

const getUserDataFromAccount = (accountsData) => {
    const adapter = new DataAdapter(accountsData);
    return adapter.transform();
}

// Класс, представляющий целевую структуру данных
class TargetData {
    constructor() {
        this.email = "";
        this.email2 = "";
        this.fname = "";
        this.mname = "";
        this.sname = "";
        this.phone = "";
        this.gender = 0;
        this.id_1chotel = "";
        this.city = "";
        this.birthday = 0;
        this.date_confirm_email = 0;
        this.date_confirm_email2 = 0;
        this.date_upload_profbilet = 0;
        this.profkomphone = "";
        this.isul = 0;
        this.legal_name = "";
        this.bill = undefined;
        this.overdraft = undefined;
        this.balance = undefined;
        this.hasUlAndFlAccounts = false;
    }
}

// Адаптер, который преобразует исходные данные в целевую структуру
class DataAdapter {
    constructor(inputData) {
        this.inputData = inputData;
    }

    // Метод для преобразования данных
    transform() {
        if (this.inputData.xAccounts && Array.isArray(this.inputData.xAccounts) && this.inputData.xAccounts.length > 0) {
            let account = this.inputData.xAccounts.find(item => !!item.isAutentification && item.xAccountUId === this.inputData.current_XAccountUId);

            if (account) {
                const targetData = new TargetData();
                targetData.sname = account.params?.LastName || "";
                targetData.fname = account.params?.FirstName || "";
                targetData.mname = account.params?.MiddleName || "";
                targetData.city = account.params?.City || "";
                targetData.id_1chotel = account.params?.id_1chotel || "";
                targetData.phone = account.params?.phone ? account.params.phone.replace(/\D/g, "") : "";
                targetData.gender = account.params?.Gender && account.params.Gender === 'Мужской' ? 1 : 0;
                targetData.birthday = account.params?.birthdate ? Math.max(0, moment.utc(account.params.birthdate, 'YYYY.MM.DD').unix()) : 0;
                targetData.email = account.params?.email || "";
                targetData.date_confirm_email = account.params?.date_confirm_email ? Math.max(0, moment.utc(account.params?.date_confirm_email, 'YYYY.MM.DD').unix()) : 0;
                targetData.email2 = account.params?.email_gaz || "";
                targetData.date_confirm_email2 = account.params?.email_gaz_confirm ? Math.max(0, moment.utc(account.params?.email_gaz_confirm, 'YYYY.MM.DD').unix()) : 0;
                targetData.profkomphone = account.params?.profkomphone || "";
                targetData.date_upload_profbilet = account.params?.date_upload_profbilet ? Math.max(0, moment.utc(account.params?.date_upload_profbilet, 'YYYY.MM.DD').unix()) : 0;
                targetData.isul = account.accountType === 'Юридическое лицо' ? 1 : 0;
                targetData.legal_name = account.params?.LegalName ?? '';
                targetData.bill = parseFloat(account.params?.bill) ?? undefined;
                targetData.overdraft = parseFloat(account.params?.overdraft) ?? undefined;
                targetData.balance = targetData.bill !== undefined && targetData.overdraft !== undefined ? targetData.bill + targetData.overdraft : undefined;
                targetData.hasUlAndFlAccounts = !!this.inputData.xAccounts.find(item => !targetData.isul ? item.accountType === 'Юридическое лицо' : item.accountType === 'Физическое лицо');
                return targetData;
            }
        }

        return null;
    }
}

export {getUserDataFromAccount, svodApi};